module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-1.016b506e.jpg";